import React, { useEffect } from "react";
import { connect } from "react-redux";
import { css } from "emotion";

import { loadingStyle } from "./style";
import Loading from "../../../../../../shared/Loading/Loading";

import { useNewOffer } from "../../../../../../js/context/new-offer";
import { refreshOffers, isNewUser } from "../../../../../actions";
import {
	ROUTE_PREFIX_CREATE_OFFER_MOBILE,
	prefixFinished,
	prefixFinishedError
} from "../../../../../shared/constants";
import { handleFidelityNameToPath } from "../../../../../shared/utils";

const StepCreateFinished = ({ refreshOffers, isNewUser, history }) => {
	const { currentProgram, offerSentStatus, fetchOffersData } = useNewOffer();

	useEffect(() => {
		if (offerSentStatus.isDone) {
			fetchOffersData(); // atualiza offers do context
			refreshOffers(); // atualiza offers do redux
			isNewUser(false); // atualiza caso for novo usuario trocar a tela inicial
			if (offerSentStatus.success) {
				history.push(
					`${ROUTE_PREFIX_CREATE_OFFER_MOBILE}/${prefixFinished}/${handleFidelityNameToPath(
						currentProgram
					)}`
				);
			} else {
				history.push(
					`${ROUTE_PREFIX_CREATE_OFFER_MOBILE}/${prefixFinishedError}/${handleFidelityNameToPath(
						currentProgram
					)}`
				);
			}
		}
	}, [offerSentStatus]);

	return (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<strong>Quase lá!</strong>
			<span>Estamos finalizando seu cadastro.</span>
			<Loading width={120} height={120} />
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers()),
		isNewUser: newUser => dispatch(isNewUser(newUser))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(StepCreateFinished);
